import { render, staticRenderFns } from "./PersistResponsavelHistoricoSmsView.vue?vue&type=template&id=5480d0d4&"
import script from "./PersistResponsavelHistoricoSmsView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelHistoricoSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports